// 고객사 기능 배정 화면 모양 — 2026-11-04 TenantModuleView.jsx(316줄)에서 글자 그대로 옮김(300줄 규칙, 동작 변화 없음).
export function badgeStyle(color, filled = false) {
  return {
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 6,
    border: `1px solid ${color}`,
    background: filled ? color : 'var(--bg-card)',
    color: filled ? '#fff' : color,
    padding: '2px 7px',
    fontSize: 11,
    fontWeight: 900,
    lineHeight: 1.2,
    whiteSpace: 'nowrap',
  };
}

export function tenantButtonStyle(active) {
  return {
    border: `1px solid ${active ? '#2563eb' : 'var(--border)'}`,
    background: active ? 'rgba(37,99,235,0.12)' : 'var(--bg-card)',
    color: active ? '#2563eb' : 'var(--text)',
    borderRadius: 8,
    padding: '8px 10px',
    cursor: 'pointer',
    textAlign: 'left',
    minWidth: 150,
  };
}

export function moduleFilterButtonStyle(active) {
  return {
    border: `1px solid ${active ? '#2563eb' : 'var(--border)'}`,
    borderRadius: 7,
    background: active ? 'rgba(37,99,235,0.12)' : 'var(--bg-card)',
    color: active ? '#2563eb' : 'var(--text-sub)',
    padding: '5px 8px',
    fontSize: 12,
    fontWeight: 850,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  };
}

export function moduleSearchStyle() {
  return {
    width: 220,
    maxWidth: '100%',
    border: '1px solid var(--border)',
    borderRadius: 7,
    background: 'var(--bg-card)',
    color: 'var(--text)',
    padding: '6px 9px',
    fontSize: 12,
    fontWeight: 750,
    outline: 'none',
  };
}
